import React, { forwardRef } from 'react';
import cx from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../../utilities/IBuildrProps';
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../../utilities/automation';

interface IFormProps extends IBuildrProps {
    children: any;
    buttonType: 'submit' | 'reset' | 'button';
    buttonText: string;
}

export default styled(forwardRef(function({
    cmsId,
    editorClassObj,
    className,
    buttonType = 'submit',
    buttonText = 'Submit'
}: IFormProps, ref: any) {
    return (
        <button type={buttonType} data-id={cmsId} ref={ref} className={cx(className, editorClassObj)} data-test-id={createDataTestId({ feature: AutomationTestIdFeature.FORM, element: AutomationTestIdElementType.BUTTON, specifier: buttonType })}>
            {buttonText}
        </button>
    );
}))``;
